// At the top with other imports
import AppointmentBooking from '../AppointmentBooking/AppointmentBooking'; // Adjust path as needed
import useAppointmentBooking from '../ShareComp/useAppointmentBooking';


import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"; 
import './body.css'; // Assuming you'll create a Body.css file

import { db } from '../../Components/LoginComp/firebase';
import { collection, addDoc, query, where, getDocs, serverTimestamp  } from 'firebase/firestore';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { 
  MdAccessTime, MdClose, MdCheckCircle, MdLocationOn, MdPeople, 
  MdEmail, MdPhone, MdPerson, MdNotes, MdEvent, MdVolumeUp 
} from 'react-icons/md';

import emailjs from 'emailjs-com';

import { FaArrowRight } from 'react-icons/fa';


import { FaBook, FaQuoteLeft, FaRandom } from 'react-icons/fa';


const localizer = momentLocalizer(moment);



function Body() {


const images = ['b1.jpg', 'b2.jpg', 'b3.jpg', 'b4.jpg']; 
const [currentImageIndex, setCurrentImageIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % images.length
    );
  }, 10000); // Change image every 10 seconds (slower)

  return () => clearInterval(interval);
}, []);





//dhamma pada short section
// Selected verses from different chapters
  const featuredVerses = [
    {
      text: "Mind precedes all mental states. Mind is their chief; they are all mind-wrought. If with a pure mind a person speaks or acts happiness follows him like his never-departing shadow.",
      chapter: 1,
      number: 2
    },
    {
      text: "Hatred is never appeased by hatred in this world. By non-hatred alone is hatred appeased. This is a law eternal.",
      chapter: 1,
      number: 5
    },
    {
      text: "As a fish when pulled out of water and cast on land throbs and quivers, even so is this mind agitated. Hence should one abandon the realm of Mara.",
      chapter: 3,
      number: 34
    },
    {
      text: "Like a beautiful flower full of color and also fragrant, even so, fruitful are the fair words of one who practices them.",
      chapter: 4,
      number: 52
    },
    {
      text: "Better than a thousand useless words is one useful word, hearing which one attains peace.",
      chapter: 8,
      number: 100
    },
    {
      text: "To avoid all evil, to cultivate good, and to cleanse one's mind – this is the teaching of the Buddhas.",
      chapter: 14,
      number: 183
    },
    {
      text: "Health is the most precious gain and contentment the greatest wealth. A trustworthy person is the best kinsman, Nibbana the highest bliss.",
      chapter: 15,
      number: 204
    }
  ];

  const [currentVerse, setCurrentVerse] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const getRandomVerse = () => {
    const randomIndex = Math.floor(Math.random() * featuredVerses.length);
    setCurrentVerse(randomIndex);
  };














  // Common state for both booking types
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    numberOfPeople: 1,
    location: '',
    specialRequests: ''
  });
  const [showForm, setShowForm] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [activeTab, setActiveTab] = useState('alms');

  // Alms Giving specific state
  const [selectedMealType, setSelectedMealType] = useState('');
  const [bookedDates, setBookedDates] = useState({ breakfast: [], lunch: [] });

  // Dhamma Speech/Pirith Chanting specific state
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [bookedEvents, setBookedEvents] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  // Define available time slots for events
  const eventTypes = {
    'Pirith Chanting / Dhamma Speech': [
      { time: '8:00 AM - 10:00 AM', id: 'morning' },
      { time: '3:00 PM - 5:00 PM', id: 'afternoon' },
      // { time: '4:00 PM - 5:00 PM', id: 'late_afternoon' },
      { time: '7:00 PM - 9:00 PM', id: 'evening' }
    ]
  };

  // Fetch already booked dates for Alms Giving
  useEffect(() => {
    const fetchBookedDates = async () => {
      try {
        const breakfastQuery = query(collection(db, 'appointments'), where('mealType', '==', 'breakfast'));
        const lunchQuery = query(collection(db, 'appointments'), where('mealType', '==', 'lunch'));
        
        const [breakfastSnapshot, lunchSnapshot] = await Promise.all([
          getDocs(breakfastQuery),
          getDocs(lunchQuery)
        ]);

        const breakfastDates = breakfastSnapshot.docs.map(doc => {
          const data = doc.data();
          return data.date?.toDate() || null;
        }).filter(date => date !== null);

        const lunchDates = lunchSnapshot.docs.map(doc => {
          const data = doc.data();
          return data.date?.toDate() || null;
        }).filter(date => date !== null);

        setBookedDates({
          breakfast: breakfastDates,
          lunch: lunchDates
        });
      } catch (error) {
        console.error("Error fetching booked dates:", error);
        setBookedDates({ breakfast: [], lunch: [] });
      }
    };

    if (activeTab === 'alms') {
      fetchBookedDates();
    }
  }, [activeTab]);

  // Fetch already booked events for Dhamma Speech/Pirith Chanting
  useEffect(() => {
    const fetchBookedEvents = async () => {
      try {
        const eventsQuery = query(collection(db, 'dhammaEvents'));
        const snapshot = await getDocs(eventsQuery);
        
        const events = snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            date: data.date?.toDate() || null,
            timeSlot: data.timeSlot || ''
          };
        }).filter(event => event.date !== null);

        setBookedEvents(events);
      } catch (error) {
        console.error("Error fetching booked events:", error);
        setBookedEvents([]);
      }
    };

    if (activeTab === 'dhamma') {
      fetchBookedEvents();
    }
  }, [activeTab]);

  // Generate time slots for selected date (Dhamma Speech/Pirith Chanting)
  useEffect(() => {
    if (selectedDate && activeTab === 'dhamma') {
      const today = new Date();
      const isToday = moment(selectedDate).isSame(today, 'day');
      
      const slots = eventTypes['Pirith Chanting / Dhamma Speech'].map(slot => {
        const [startTime, endTime] = slot.time.split(' - ');
        const slotStart = moment(selectedDate).set({
          hour: parseInt(startTime.split(':')[0]) + (startTime.includes('PM') && parseInt(startTime.split(':')[0]) !== 12 ? 12 : 0),
          minute: parseInt(startTime.split(':')[1].split(' ')[0]),
          second: 0
        }).toDate();
        
        const isPast = isToday && new Date() > slotStart;
        const isBooked = bookedEvents.some(event => 
          moment(event.date).isSame(selectedDate, 'day') && 
          event.timeSlot === slot.id
        );

        return {
          ...slot,
          isPast,
          isBooked,
          startTime: slotStart
        };
      });

      setTimeSlots(slots);
    }
  }, [selectedDate, bookedEvents, activeTab]);

  // Common handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const navigateMonth = (months) => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + months);
    setCurrentMonth(newMonth);
  };

  // Alms Giving handlers
  const handleAlmsDateSelect = (date, mealType) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      alert('You cannot select a past date');
      return;
    }

    const isBooked = bookedDates[mealType]?.some(bookedDate => 
      moment(bookedDate).isSame(date, 'day')
    ) || false;

    if (isBooked) {
      alert(`This date is already booked for ${mealType} Offering`);
      return;
    }

    setSelectedDate(date);
    setSelectedMealType(mealType);
    setShowForm(true);
  };

  const almsEventStyleGetter = (date, mealType) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      return {
        className: 'past-date',
        style: {
          cursor: 'not-allowed'
        }
      };
    }

    const isBooked = bookedDates[mealType]?.some(bookedDate => 
      moment(bookedDate).isSame(date, 'day')
    ) || false;

    if (isBooked) {
      return {
        className: 'booked-date',
        style: {
          cursor: 'not-allowed'
        }
      };
    }

    return {
      className: `available-date ${mealType}`,
      style: {
        cursor: 'pointer'
      }
    };
  };

  // Dhamma Speech/Pirith Chanting handlers
  const handleDhammaDateSelect = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      alert('You cannot select a past date');
      return;
    }

    setSelectedDate(date);
  };

  const handleTimeSlotSelect = (slot) => {
    if (slot.isPast) {
      alert('This time slot has already passed');
      return;
    }

    if (slot.isBooked) {
      alert('This time slot is already booked');
      return;
    }

    setSelectedEvent(slot);
    setShowForm(true);
  };

  const dhammaEventStyleGetter = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      return {
        className: 'past-date',
        style: {
          cursor: 'not-allowed'
        }
      };
    }

    const hasBookings = bookedEvents?.some(event => 
      moment(event.date).isSame(date, 'day')
    ) || false;

    return {
      className: hasBookings ? 'has-bookings' : 'available-date',
      style: {
        cursor: 'pointer'
      }
    };
  };

  // Form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    
  //   try {
  //     if (activeTab === 'alms') {
  //       await addDoc(collection(db, 'appointments'), {
  //         ...formData,
  //         date: selectedDate,
  //         mealType: selectedMealType,
  //         createdAt: new Date()
  //       });

  //       setBookedDates(prev => ({
  //         ...prev,
  //         [selectedMealType]: [...prev[selectedMealType], selectedDate]
  //       }));
  //     } else {
  //       await addDoc(collection(db, 'dhammaEvents'), {
  //         ...formData,
  //         eventType: 'Pirith Chanting / Dhamma Speech',
  //         date: selectedDate,
  //         timeSlot: selectedEvent.id,
  //         timeSlotDisplay: selectedEvent.time,
  //         createdAt: new Date()
  //       });

  //       setBookedEvents(prev => [
  //         ...prev,
  //         {
  //           eventType: 'Pirith Chanting / Dhamma Speech',
  //           date: selectedDate,
  //           timeSlot: selectedEvent.id,
  //           timeSlotDisplay: selectedEvent.time
  //         }
  //       ]);
  //     }

  //     setSubmissionSuccess(true);
  //     setShowForm(false);
      
  //     setTimeout(() => {
  //       setSubmissionSuccess(false);
  //       setFormData({
  //         name: '',
  //         phone: '',
  //         email: '',
  //         address: '',
  //         numberOfPeople: 1,
  //         location: '',
  //         specialRequests: ''
  //       });
  //     }, 3000);
  //   } catch (error) {
  //     console.error('Error adding document: ', error);
  //     alert('There was an error submitting your booking. Please try again.');
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (!formData.name || !formData.email || !formData.phone) {
        throw new Error('Please fill all required fields');
      }
  
      const bookingDate = selectedDate || new Date();
      const bookingData = {
        ...formData,
        date: bookingDate,
        type: activeTab,
        status: 'pending',
        ...(activeTab === 'alms' && { 
          mealType: selectedMealType || 'lunch',
          timeSlot: selectedMealType === 'breakfast' ? 'morning' : 'afternoon'
        }),
        ...(activeTab !== 'alms' && { 
          eventType: 'Pirith Chanting / Dhamma Speech',
          timeSlot: selectedEvent?.id || 'default',
          timeSlotDisplay: selectedEvent?.time || 'To be determined'
        }),
        createdAt: new Date(),
        updatedAt: new Date()
      };
  
      // Save to Firestore
      let docRef;
      try {
        const collectionName = activeTab === 'alms' ? 'appointments' : 'dhammaEvents';
        docRef = await addDoc(collection(db, collectionName), bookingData);
        console.log('Firestore document written with ID: ', docRef.id);
        
        // Update local state immediately after successful Firestore save
        if (activeTab === 'alms') {
          setBookedDates(prev => ({
            ...prev,
            [selectedMealType]: [...prev[selectedMealType], bookingDate]
          }));
        } else {
          setBookedEvents(prev => [
            ...prev,
            {
              date: bookingDate,
              timeSlot: selectedEvent?.id || 'default',
              timeSlotDisplay: selectedEvent?.time || 'To be determined'
            }
          ]);
        }
      } catch (firebaseError) {
        console.error('Firebase save failed:', firebaseError);
        throw new Error('Failed to save booking. Please try again.');
      }
  
      // Send Email to Admin
      try {
        await emailjs.send('service_598u6ac', 'template_soq22lx', {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          address: formData.address,
          number_of_people: formData.numberOfPeople,
          location: formData.location,
          special_requests: formData.specialRequests,
          booking_type: activeTab === 'alms' 
            ? `Alms Giving (${selectedMealType})` 
            : `Dhamma Event (${selectedEvent?.time || 'Unknown time'})`,
          booking_date: bookingDate.toDateString()
        }, 'ecZ5RdpZWV8Tut7Ao');
  
        console.log('Admin notification email sent successfully');
      } catch (emailError) {
        console.error('Email sending failed:', emailError);
        // Don't throw error here - the booking was successful even if email failed
      }
  
      setSubmissionSuccess(true);
      setShowForm(false);
      alert('Booking saved successfully!');
      
      setTimeout(() => {
        setFormData({
          name: '',
          phone: '',
          email: '',
          address: '',
          numberOfPeople: 1,
          location: '',
          specialRequests: ''
        });
        setSubmissionSuccess(false);
      }, 3000);
  
    } catch (error) {
      console.error('Booking submission error:', error);
      alert(error.message || 'An unexpected error occurred. Please try again.');
    }
  };
  













  // Custom Toolbar Component
  const CustomToolbar = (toolbar) => {
    return (
      <div className="rbc-toolbar">
        <div className="month-navigation">
          <button 
            type="button" 
            onClick={() => navigateMonth(-1)}
            className="nav-button"
          >
            &lt;
          </button>
          <span className="rbc-toolbar-label">
            {toolbar.label}
          </span>
          <button 
            type="button" 
            onClick={() => navigateMonth(1)}
            className="nav-button"
          >
            &gt;
          </button>
        </div>
      </div>
    );
  };






    const [formDonateData, setFormDonateData] = useState({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      date: '',
      amount: '',
      reason: ''
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    // Add this useEffect to track tab changes
    useEffect(() => {
      console.log(`Active tab changed to: ${activeTab}`);
      // You can add any tab-specific logic here
      // For example, reset form when switching to monastery tab:
      if (activeTab === 'monastery') {
        setFormDonateData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          address: '',
          date: '',
          amount: '',
          reason: ''
        });
      }
    }, [activeTab]); // This will run whenever activeTab changes
    
    const handleChange = (e) => {
      const { id, value } = e.target;
      setFormDonateData(prev => ({
        ...prev,
        [id]: value
      }));
    };
    
    const handleDonateSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      
      try {
        const docRef = await addDoc(collection(db, "monasteryDonations"), {
          ...formDonateData,
          currency: 'AUD',
          createdAt: serverTimestamp()
        });
        
        console.log("Document written with ID: ", docRef.id);
        alert('Thank you! Your donation details have been successfully submitted.');
        
        setFormDonateData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          address: '',
          date: '',
          amount: '',
          reason: ''
        });
      } catch (error) {
        console.error("Error adding document: ", error);
        alert('There was an error submitting your donation. Please try again.');
      } finally {
        setIsSubmitting(false);
      }
    };










    const [isStoryOpen, setIsStoryOpen] = useState({
      story1: false,
      story2: false,
      story3: false,
    });
    
    const toggleStory = (storyKey) => {
      setIsStoryOpen((prevState) => ({
        ...prevState,
        [storyKey]: !prevState[storyKey],
      }));
    };




// In your component where you use it:
const appointmentProps = useAppointmentBooking();

  return (
    <>
    <div className="carousel">
      <div className="carousel-inner">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            className={`carousel-item ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))}
        
        <Link to="/appointment">
          <button className="appointment-button"> Appointment</button>
        </Link>
      </div>
    </div>

    {/* <div className="heading-ehipassiko">
      <h1>Ehipassiko Buddhist Center </h1>
    </div> */}
    





  <div className="appointment-container">
        {/* Use the shared component */}
        <AppointmentBooking {...appointmentProps} />

      {/* <div className="booking-tabs">
        <button
          className={`tab-button ${activeTab === 'alms' ? 'active' : ''}`}
          onClick={() => setActiveTab('alms')}
        >
          Alms Giving
        </button>
        <button
          className={`tab-button ${activeTab === 'dhamma' ? 'active' : ''}`}
          onClick={() => setActiveTab('dhamma')}
        >
          Dhamma Speech/Pirith Chanting
        </button>

        <button className={`tab-button ${activeTab === 'monastery' ? 'active' : ''}`} onClick={() => setActiveTab('monastery')}>
      Daily expenses of the monastery
    </button>
      </div>





      {activeTab === 'monastery' && (
        <div className="donation-container">
        <h3>Daily Expenses of Monastery </h3>
        <div className="donation-form-layout">
          <div className="form-column">
            <form onSubmit={handleDonateSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input 
                  type="text" 
                  id="firstName" 
                  value={formDonateData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input 
                  type="text" 
                  id="lastName" 
                  value={formDonateData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  value={formDonateData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  value={formDonateData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="address">Address</label>
                <textarea 
                  id="address" 
                  value={formDonateData.address}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                  <label htmlFor="donationDate">Select a Date</label>
                  <input
                    type="date"
                    id="donationDate"
                    value={formDonateData.donationDate}
                    onChange={handleChange}
                    required
                  />
                </div>


              <div className="form-group">
                <label htmlFor="amount">Amount</label>
                <input 
                  type="amount" 
                  id="amount" 
                  value={formDonateData.amount}
                  onChange={handleChange}
                  required
                />
              </div>
              
              
              <div className="form-group">
                <label htmlFor="reason">Reason for the Donation</label>
                <textarea 
                  id="reason" 
                  value={formDonateData.reason}
                  onChange={handleChange}
                />
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Details'}
              </button>
            </form>
          </div>
          
          <div className="details-column">
            <div className="bank-info">
            <p>With a heart full of gratitude, we humbly invite you to contribute towards the daily expenses of the monastery.
   Your generous offering, however small, helps sustain the spiritual activities and serene environment that benefit all beings.

   May the merits of your support bring peace, happiness, and spiritual blessings to you and your loved ones. 🙏🪷
    </p>
       <p><b>Kindly request to send your transaction slip to our WhatsApp Account (+61 45 12 900 85). Thank you! 🙏
       </b></p><br/>
       
              <h4>Bank Account Information:</h4>
              <p><strong>Bank:</strong> Commonwealth Bank</p>
              <p><strong>Account Name:</strong> ENLIGHTENED PATH FELLOWSHIP INC.</p>
              <p><strong>BSB:</strong> 063-599</p>
              <p><strong>Account number:</strong> 1128 2820</p>
              <p><strong>BIC/SWIFT Code:</strong> CTBAAU2S</p>
            </div>
          </div>
        </div>
        </div>
        )}














      {activeTab === 'alms' ? (
        <>
          <div className="appointment-header">
            <h1 className="appointment-title">Alms Giving Appointment</h1>
            <p className="appointment-subtitle">Select a date for your alms giving offering</p>
          </div>

          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color breakfast"></span>
              <span>Breakfast Offering (6:00 AM - 8:00 AM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color lunch"></span>
              <span>Lunch Offering (10:30 AM - 12:30 PM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color booked"></span>
              <span>Booked Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>

          <div className="calendar-container">
            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Breakfast Offering
                  <span className="time-slot">6:00 AM - 8:00 AM</span>
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'breakfast')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'breakfast')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>

            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Lunch Offering
                  <span className="time-slot">10:30 AM - 12:30 PM</span>
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'lunch')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'lunch')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="booking-header">
            <h1 className="booking-title">Dhamma Speech & Pirith Chanting Booking</h1>
            <p className="booking-subtitle">Schedule your spiritual event with our venerable monks</p>
          </div>

          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color available"></span>
              <span>Available Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color has-bookings"></span>
              <span>Dates with Bookings</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>

          <div className="calendar-container">
            <div className="dhamma-calendar">
              <div className="calendar-header">
                <h2>
                  <MdEvent className="event-icon" /> 
                  Available Dates
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleDhammaDateSelect(slotInfo.start)}
                dayPropGetter={(date) => dhammaEventStyleGetter(date)}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>

            {selectedDate && (
              <div className="time-slots-container">
                <div className="time-slots-header">
                  <h2>
                    <MdVolumeUp className="event-icon" /> 
                    Available Time Slots for {moment(selectedDate).format('LL')}
                  </h2>
                </div>
                <div className="time-slots-grid">
                  {timeSlots.map((slot, index) => (
                    <div 
                      key={index}
                      className={`time-slot-card ${slot.isPast ? 'past-slot' : ''} ${slot.isBooked ? 'booked-slot' : ''}`}
                      onClick={() => !slot.isPast && !slot.isBooked && handleTimeSlotSelect(slot)}
                    >
                      <div className="slot-time">
                        <MdAccessTime />
                        {slot.time}
                      </div>
                      <div className="slot-status">
                        {slot.isPast ? (
                          <span className="status-badge past">Time Passed</span>
                        ) : slot.isBooked ? (
                          <span className="status-badge booked">Booked</span>
                        ) : (
                          <button className="book-button">Book Appointment</button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {showForm && (
        <div className="appointment-form-overlay">
          <div className="appointment-form-container">
            <div className="form-header">
              <h3>
                {activeTab === 'alms' 
                  ? `${selectedMealType === 'breakfast' ? 'Breakfast' : 'Lunch'} Offering`
                  : 'Pirith Chanting / Dhamma Speech'}
                <span className="form-date">{moment(selectedDate).format('LL')}</span>
              </h3>
              <button 
                className="close-form" 
                onClick={() => setShowForm(false)}
              >
                <MdClose />
              </button>
            </div>
            
            <div className="time-display">
              <MdAccessTime />
              {activeTab === 'alms'
                ? selectedMealType === 'breakfast' ? '6:00 AM - 8:00 AM' : '10:30 AM - 12:30 PM'
                : selectedEvent.time}
            </div>

            <form onSubmit={handleSubmit} className="appointment-form">
              <div className="form-group">
                <label>
                  <MdPerson className="input-icon" /> Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPhone className="input-icon" /> Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdEmail className="input-icon" /> Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdLocationOn className="input-icon" /> Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPeople className="input-icon" /> 
                  {activeTab === 'alms' ? 'Number of Monks' : 'Expected Attendees'}
                </label>
                <input
                  type="number"
                  name="numberOfPeople"
                  min="1"
                  max={activeTab === 'alms' ? "50" : "100"}
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {activeTab === 'alms' && (
                <div className="form-group">
                  <label>
                    <MdLocationOn className="input-icon" /> Location for Offering
                  </label>
                  <select
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    className="location-select"
                  >
                    <option value="">Select a location</option>
                    <option value="Ehipassiko Buddhist Centre">Ehipassiko Buddhist Centre</option>
                    <option value="My Home (Above Address)">My Home (Above Address)</option>
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>
                  <MdNotes className="input-icon" /> Special Requests
                </label>
                <textarea
                  name="specialRequests"
                  value={formData.specialRequests}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder={
                    activeTab === 'alms' 
                      ? 'Any special requirements or notes'
                      : 'Any special requirements or topics for Dhamma speech'
                  }
                />
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  Confirm Booking
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {submissionSuccess && (
        <div className="success-message-overlay">
          <div className="success-message">
            <MdCheckCircle className="success-icon" />
            <h3>Booking Confirmed Successfully!</h3>
            <p>
              Your {activeTab === 'alms'
                ? `${selectedMealType} offering on ${moment(selectedDate).format('LL')}`
                : `Pirith Chanting / Dhamma Speech on ${moment(selectedDate).format('LL')} at ${selectedEvent.time}`} 
              has been booked.
            </p>
            <p>Successfully Submitted.</p>
            <button 
              className="success-close-btn"
              onClick={() => setSubmissionSuccess(false)}
            >
              Close
            </button>
          </div>
        </div>
      )} */}
    </div>





    <div className='middle-prent-layer'>
  <div className='middle-content-wrapper'> 
      <div className='middle-visual-container'>
      <img 
        src="/arama poojawa.jpeg" 
        alt="Arama Poojawa" 
        className='middle-sacred-image'
        loading='lazy'
      />
 
    </div>
    
    <div className='middle-sacred-description'>
      <div className='middle-lotus-icon'>උත්තම ආරාම පූජාව</div>
      {/* <h3 className='middle-dhamma-title'><i></i><br /></h3> */}
      <p className='middle-buddha-text'>සිව්දිගින් වඩින මහා සංඝරත්නය උදෙසා  යමෙක් කුටි සෙනසුන් 
        සාදා පූජා කරනු ලබත් ද හේ වනාහී සියල්ල දන් දුන්නා වේ. (කිංදද සූත්‍රය)
      </p>
        <h3 className='middle-dhamma-title'><b>ඕස්ට්‍රේලියාවේ මෙල්බර්න් ඒහිපස්සිකෝ බෞද්ධ මධ්‍යස්ථානය</b></h3>


      <div className='middle-event-schedule'>
        {/* <div className='middle-schedule-day'>


          <h4>කඨින චීවරය පිංවත් ඔබේ නිවසේ තැන්පත් කරන කාලය තුලදී  සිදු කළ යුතු වත්පිළිවෙත්</h4>

          <p>සුගත චීවරය සහ කඨින චීවරය තබන ස්ථානය පිරිසිදුව තබා ගැනීම </p> 

          <p>දෛනිකව උදේ/සවස පන්සිල් සමාදන්ව තෙරුවන් නැමදීම </p>

          <p>පිරිත් දේශනා කිරීම (තුන් සූත්‍ර දේශනාව හෝ කරණියමෙත්ත සූත්‍රය)</p>

          <p>දෙවියන්ට හා මියගිය අයට පිං අනුමෝදන් කිරීම</p>

          <p>චීවරය නිවසේ පවතින් කාල සීමාව තුළ නිර්මාංශව සිටීමට හැකි නම් මැනවි</p>

          <p>කඨින චීවරය නිවසට වැඩම කරවන දිනයෙහි භික්ෂූන් වහන්සේ නමක්
             වැඩම කරවාගෙන ආනිශංස දේශනාවක් සිදුකර ගැනීම </p>

          <p>(මෙය අත්‍යවශ්‍යම නොවේ පහසුකම් ඇත අය පමණක් කරන්නේ නම් මැනවි)</p>
        </div> */}
        

        


        {/* <p className='middle-buddha-text'><b>
        🌸 කඨින මහා පිංකම සදහා වැඩමවන ගෞරවණීය මහා සංඝ රත්නය උදෙසා පූජා කිරීමට බලාපොරොත්තු වන පරිෂ්කාර පූජාවන් සදහා දායකත්වයන්  </b></p>
    */}
       </div>


      
      <div className='middle-contact-info'>
        <p>මේ උතුම් පිංකම සඳහා ඔබටත් මෙත් සිතින් ආරාධනා.!</p>
        {/* <p> අෂ්ටපරිෂ්කාර පූජාවක් සදහා $100</p>
        <p>චීවර පරිෂ්කාර පූජාවක් සදහා $50</p>
        <p>මූල්‍යම පරිෂ්කාර පූජාවන් සදහා $100-$500</p>
        <p>ගරුභාණ්ඩ පරිෂ්කාර පූජාවන් සදහා $500</p>< br /> */}

        <p>4 Schotters Rd, Mernda, VIC 3754</p>
        <p>සියලු විමසීම් : <strong>045 12 900 85</strong></p>
      </div>



    </div>


    
  </div>
</div>







    <div className="body-container">

      <div className="upcoming-event-container">
      <div className="upcoming-event-fixed">
          <h2>Upcoming Events</h2>
          <ul>
            <li>13 Jan Mon – Duruthu Full Moon Poya Day</li>
            <li>12 Feb Wed – Navam Full Moon Poya Day</li>
            <li>13 Mar Thu – Madin Full Moon Poya Day</li>
            <li>12 Apr Sat – Bak Full Moon Poya Day</li>
            <li>12 May Mon – Vesak Full Moon Poya Day</li>
            <li>10 Jun Tue – Poson Full Moon Poya Day</li>
            <li>10 Jul Thu – Esala Full Moon Poya Day</li>
            <li>8 Aug Fri – Nikini Full Moon Poya Day</li>
            <li>7 Sep Sun – Binara Full Moon Poya Day</li>
            <li>6 Oct Mon – Vap Full Moon Poya Day</li>
            <li>5 Nov Wed – Ill Full Moon Poya Day</li>
            <li>4 Dec Thu – Unduvap Full Moon Poya Day</li>
          
          </ul>
        </div>


        <div className="recent-youtube">
          <h2>Recent Youtube</h2>
          <div className="youtube-video-placeholder">
            {/* Replace with actual YouTube video embed or image */}
            <iframe width="560" height="315" src="https://www.youtube.com/embed/XDR8NwSgkpA?si=_TtGpdsFHSFwI7jV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <p>2025 Navam Poya day</p>
          <Link to="https://www.youtube.com/embed/XDR8NwSgkpA?si=_TtGpdsFHSFwI7jV"
               target="_blank"
               rel="noopener noreferrer">
          <button className="read-more-btn">READ MORE</button></Link>

          <div className="youtube-video-placeholder">
            {/* Replace with actual YouTube video embed or image */}
            <iframe width="560" height="315" src="https://www.youtube.com/embed/XuGXrYqLt9Y?si=WzltcQG4w92NL3UN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>          </div>
          <p>Sadaham Sermon on Valentine's Day</p>
          <Link to="https://www.youtube.com/watch?v=XuGXrYqLt9Y"
               target="_blank"
               rel="noopener noreferrer">
          <button className="read-more-btn">READ MORE</button></Link>
        </div>
      </div>


      <div className="daily-time-table">
        <h2>Daily Time Table</h2>
        <div className="time-table-items">
          <div className="time-table-item">
            <span className="time">5:00 am - 6:00 am</span>
            <span className="activity">Worship and homage to Lord Buddha and practice Meditation</span>
          </div>
          <div className="time-table-item">
            <span className="time">6:00 am - 8:00 am</span>
            <span className="activity">Breakfast Offering and spiritual services (Home visit on request)</span>
          </div>
          <div className="time-table-item">
            <span className="time">9:00 am - 10:00 am</span>
            <span className="activity">Dhamma discussion, Buddhist Counselling</span>
          </div>
          <div className="time-table-item">
            <span className="time">10:30 am - 12:30 pm</span>
            <span className="activity">Lunch Offering and spiritual services (Home visit on request)</span>
          </div>
          <div className="time-table-item">
            <span className="time">02:00 pm - 03:30 pm</span>
            <span className="activity">Studies and Research</span>
          </div>
          <div className="time-table-item">
            <span className="time">4:00 pm - 6:00 pm</span>
            <span className="activity">Meet the devotees on appointments</span>
          </div>
          <div className="time-table-item">
            <span className="time">6:30 pm - 9:00 pm</span>
            <span className="activity">Worship and homage to the Lord Buddha, practice Meditation And Chanting (Home visit on request)</span>
          </div>
        </div>
      </div>
    </div>




    <section className="success-stories">
  <h2 className="section-title">Community Impact Stories</h2>
  <div className="stories-grid">
    
    <div className="story-card">
      <div className="story-image">
        <img src="/read1.jpeg" alt="Mindfulness for Rural Communities" />
      </div>
      <h3>Mindfulness for Rural Communities</h3>
      <p>Bringing meditation and mindfulness practices to remote villages.</p>
      <button className="btn-text" onClick={() => toggleStory("story1")}>
        Read Story <FaArrowRight />
      </button>
      {isStoryOpen.story1 && (
        <div className="story-detail">
          <p>Through our outreach programs, we conducted mindfulness workshops in rural areas, helping hundreds to cultivate inner peace, reduce stress, and develop wholesome living habits rooted in Buddhist teachings.</p>
        </div>
      )}
    </div>

    <div className="story-card">
      <div className="story-image">
        <img src="/img5.JPG" alt="Children's Dhamma Education" />
      </div>
      <h3>Children's Dhamma Education</h3>
      <p>Nurturing compassion and wisdom in young hearts through special programs.</p>
      <button className="btn-text" onClick={() => toggleStory("story2")}>
        Read Story <FaArrowRight />
      </button>
      {isStoryOpen.story2 && (
        <div className="story-detail">
          <p>We organized Dhamma school programs for children across several regions, guiding over 1,500 students in Buddhist values, mindfulness, and compassionate living, ensuring the next generation grows with wisdom and kindness.</p>
        </div>
      )}
    </div>

    <div className="story-card">
      <div className="story-image">
        <img src="/read3.jpeg" alt="Retreats for Inner Peace" />
      </div>
      <h3>Retreats for Inner Peace</h3>
      <p>Helping hundreds find clarity and calm through meditation retreats.</p>
      <button className="btn-text" onClick={() => toggleStory("story3")}>
        Read Story <FaArrowRight />
      </button>
      {isStoryOpen.story3 && (
        <div className="story-detail">
          <p>Our meditation retreats offer a profound opportunity for self-discovery and spiritual growth. Hundreds of participants have experienced deeper mindfulness, emotional healing, and renewed inspiration through our carefully guided sessions.</p>
        </div>
      )}
    </div>

  </div>
</section>








   <section className="dhammapada-section">
      <div className="container">
        <div className="section-header">
          <h2>
            <FaBook /> Wisdom from the Dhammapada
          </h2>
          <p>Teachings of the Buddha for mindful living</p>
        </div>

        <div className="verse-card">
          <div className="quote-icon">
            <FaQuoteLeft />
          </div>
          
          <div className="verse-content">
            <p className="verse-text">
              "{featuredVerses[currentVerse].text}"
            </p>
            
            <div className="verse-meta">
              <span className="verse-reference">
                Dhammapada Chapter {featuredVerses[currentVerse].chapter}, Verse {featuredVerses[currentVerse].number}
              </span>
            </div>
          </div>

          <div className="verse-actions">
            <button 
              className="random-button"
              onClick={getRandomVerse}
              aria-label="Random verse"
            >
              <FaRandom /> New Verse
            </button>
            
            <button 
              className="read-more-button"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? 'Show Less' : 'Read More Verses'}
            </button>
          </div>
        </div>

        {isExpanded && (
          <div className="expanded-verses">
            <h3>Selected Teachings</h3>
            <div className="verses-grid">
              {featuredVerses.map((verse, index) => (
                <div 
                  key={index} 
                  className={`verse-item ${index === currentVerse ? 'active' : ''}`}
                  onClick={() => setCurrentVerse(index)}
                >
                  <p>"{verse.text.substring(0, 100)}..."</p>
                  <span>Chapter {verse.chapter}, Verse {verse.number}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="section-footer">
          <p>
            The Dhammapada is a collection of the Buddha's teachings in verse form. 
            It contains 423 verses divided into 26 chapters.
          </p>
          <a href="/dhammapada" className="full-link">
            Explore the Complete Dhammapada →
          </a>
        </div>
      </div>
    </section>












<div className="profile-container">
      <div className="profile-grid">
        <div className="profile-image-container">
          <img
            src="monk.png" // Make sure "dharma.png" is in your public folder or accessible
            alt="Venerable Ihala Gokarella Pasadika Thero"
            className="profile-image"
          />
        </div>
        <div className="profile-description">
          <h1  className="monk-heading">Chief Incumbent Monk – Venerable Korathota Dhammadassi Thero</h1>
          <p>
          The Chief Incumbent of The Melbourne Bundoora Ehipassiko Buddhist Centre , 
          and The International Affairs Secretary of the Vidya Samadhi National Sanga Council.
          </p>
          <p>
          Most Venerable Korathota Dhammadassi Thero was born on February 19, 1988, and ordained 
          as a novice monk (Samanera) on October 28, 1998. He received higher ordination (Upasampada) on July 18, 
          2008, at the boundary of the Jayasekhararama Temple in Kuppiyawatta, Maradana, Colombo, under the guidance 
          of the Most Venerable Hipankande Saddhasiri Anunayaka Thero and the Most Venerable Embilipitiye Rahula Nayaka Thero.
          </p>
          <p>

          Venerable Dhammadassi Thero received his primary education at Sri Somananda Government School in 
          Korathota, Kaduwela, Sri Lanka, and pursued his monastic and higher education at the Hipankande G/Vidya Samadhi Maha Pirivena
           Institute in Navagagala.

          </p>
            <p>
            From a young age, he undertook responsibilities as the head monk of temples. 
            His first temple was established under the name Kosgoda Vidya Samadhi Wijesekara Buddhist Center. 
            Since then, he has provided leadership and contributions to the development of several temples.

            </p>
            <p>
            In 2008, after completing his higher education, he was appointed as the chief monk of the Sri Dhamma Samadhi Temple in Bokundara, Piliyandala. Within ten years, he transformed the previously underdeveloped premises into a beautiful and complete temple with all facilities.

              In 2018, after dedicating himself extensively to its construction, he handed over that temple to his fellow monks, freeing himself of all responsibilities to pursue further education in Russia. With the onset of the COVID-19 pandemic, he returned to Sri Lanka and once again resided intermittently at the Hipankande Sri Pada Maha Viharaya G/Vidya Samadhi Maha Pirivena, a leading institution of his lineage, making significant contributions toward its progress.
            </p>
            <p>
            During this time, he also traveled to Thailand, Malaysia, and Europe, and rendered numerous religious services as the International Affairs Secretary of the Vidya Samadhi National Sangha Council.

            In 2024, due to his social and religious service, he was given the opportunity to travel to Melbourne, Australia. There, with the support of Mr. Krishan Sanjeewa (Chairman of the organization well known to the Thero) and Mrs. Wilani Sewwandi, all necessary arrangements were provided. During that year’s Vassa Invitation Ceremony, a grand Kathina ceremony was held.

            At that event, based on the opinions of many, the Thero initiated efforts to establish a new temple under the organization.
            </p>

        </div>
    </div>
  </div>






    </>
  );
}

export default Body;